import React from "react";
import "./InfoSection.css";
import { Link } from "react-router-dom";
import { FaClock, FaHouseUser } from "react-icons/fa";
import { FaMedal } from "react-icons/fa6";

const InfoSection = () => {
  return (
    <section className="why-us">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 d-flex align-items-stretch">
            <div className="content">
              <h3>Dlaczego My?</h3>
              <p>
                Rozumiemy, jak ważna jest szybka i trafna diagnoza. W Synavie zwracamy uwagę na wiele aspektów, które 
                mają kluczowy wpływ na jakość przeprowadzonej diagnozy i na Twój komfort, eliminując przy tym niepewność związaną
                z długim oczekiwaniem na wynik.
              </p>
              <div className="text-center">
                <Link to={"/o-nas"} className="more-btn">
                  Dowiedz się więcej<i className="bx bx-chevron-right"></i>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-8 d-flex align-items-stretch">
            <div className="icon-boxes d-flex flex-column justify-content-center">
              <div className="row">
                <div className="col-xl-4 d-flex align-items-stretch">
                  <div className="icon-box mt-xl-0">
                    <FaHouseUser className="icon" />
                    <h4>Komfort</h4>
                    <small className="text-secondary">Wizyta online na Twoich warunkach</small>
                    <p>
                      <br />
                      Skracamy dystans między Tobą a specjalistą, eliminując kolejki i bariery związane z lokalizacją.
                    </p>
                  </div>
                </div>

                <div className="col-xl-4 d-flex align-items-stretch">
                  <div className="icon-box mt-4 mt-xl-0">
                    <FaClock className="icon" />
                    <h4>Czas</h4>
                    <small className="text-secondary">Ekpresowe wystawienie opinii</small>
                    <p>
                      <br />
                      Jesteśmy świadomi emocji towarzyszącym długiemu oczekiwaniu na wynik diagnozy. Dlatego nasi specjaliści wysyłają opinię do <b>48 godzin</b> po umówionej wizycie.
                    </p>
                  </div>
                </div>

                <div className="col-xl-4 d-flex align-items-stretch">
                  <div className="icon-box mt-4 mt-xl-0">
                    <FaMedal className="icon" />
                    <h4>Jakość</h4>
                    <small className="text-secondary">Najwyższa jakość usług</small>
                    <p>
                      <br />
                      Współpracujemy wyłącznie z doświadczonymi psychologami klinicznymi, którzy pracują zgodnie z rygorystycznymi standardami diagnostycznymi.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
